<script lang="ts">
    import Select from "svelte-select"
    import { postMail } from "../../../api"
    import { newNotification } from "../../../store"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import { _ } from "svelte-i18n"
    export let operation: Operation
    export let position: OperationPosition
    export let title = $_("operations.inquiryTitle")
    export let topics: { code: number; description: string }[]

    if (!topics) {
        topics = []

        topics.push({ code: 1, description: $_("operations.generalInquiry") })

        if (operation.type == 1) {
        } else {
            topics.push({ code: 7, description: $_("operations.complaint") })
        }

        topics.push({ code: 9, description: $_("operations.other") })
    }
    export let messageRequired = true
    export let closeCallback: () => void = null

    let topic: { description?: any }
    let message: any

    let submitLoading = false
    function submitInquiry() {
        submitLoading = true
        postMail("inquiry", {
            operation,
            position,
            topic,
            message,
        })
            .then(() => {
                newNotification({
                    class: "success",
                    html: $_("operations.inquirySent"),
                    timeout: 3000,
                })
                if (closeCallback) {
                    closeCallback()
                }
            })
            .finally(() => {
                submitLoading = false
            })
    }
    let topicsValues: { [key: string]: { code: number; description: string } } = {}
    topics.forEach((t) => {
        topicsValues[t.description] = t
    })
    let topicValue = {
        label: topic?.description || "",
        value: topic || {},
    }
    $: topic = topicValue.value
</script>

<div class="rueckfrage_container">
    <h3>{title}</h3>

    {#if operation}
        <h4>{$_("operations.operationNumber", { values: { number: operation.number } })}</h4>
        <p>
            {operation.commission || ""}
            {operation.commission && operation.constructionProject ? ", " : ""}
            {operation.constructionProject || ""}
        </p>
        {#if position}
            <p>
                <b>{$_("operations.position")}:</b>
                {position.number}
            </p>
        {/if}
    {/if}

    <form on:submit|preventDefault="{submitInquiry}">
        {#if topics?.length}
            <div class="inputholder haslabel">
                <label for="">{$_("operations.topic")}</label>
                <Select
                    placeholder="{$_('operations.selectTopic')}"
                    items="{Object.entries(topicsValues).map((e) => ({ label: e[0], value: e[1] }))}"
                    bind:value="{topicValue}"
                    hideEmptyState
                    showChevron
                    clearable="{false}"
                />
            </div>
        {/if}
        <div class="inputholder haslabel">
            <label for="">{$_("operations.message")}</label>
            <textarea id="" cols="30" rows="10" placeholder="" bind:value="{message}" required="{messageRequired}"
            ></textarea>
        </div>

        <div style="display:flex; justify-content: flex-end;">
            {#if submitLoading}
                <MiniLoader />
            {:else}
                <button class="btn" type="submit">{$_("operations.submit")}</button>
            {/if}
        </div>
    </form>
</div>
